import {on, find} from '../helpers';

export const setOffset = () => {
    const desktopHeader = find('.desktop-header') || { clientHeight: 0 },
        mobileHeader = find('.mobile-header') || { clientHeight: 0 },
        offset = 40 + (desktopHeader.clientHeight || mobileHeader.clientHeight)

    try {
        document.documentElement.style.setProperty('--offset', `${offset}px`)
    } catch (e) {
        // /... no support for css variables
    }
};

on('resize', setOffset, window);

setOffset();

export const getOffset = () => {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--offset'))
}
